import styled from 'styled-components'

import { TradingAuditList } from '@root/entities/pair/ui/common/trading-audit'
import { ActivePositionDetails } from '@root/features/trade/position/active-position/ui'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type AnalyticsInfoProps = {
  pair: PairModel
} & ClassNameProps

export const AnalyticsInfo: React.FC<AnalyticsInfoProps> = ({
  className,
  pair,
}) => {
  return (
    <Root className={className}>
      <ActivePositionDetails />

      <TradingAuditList pair={pair} variant="short" />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 12px;
  padding-inline: 12px;
  padding-block: 12px;
`
